import React, {Fragment} from "react"
import { Link } from "react-router-dom"



const SideBar = (props) => {

    const {onClick, value} = props;
    
    return (
        <Fragment>

            {/* slide-bar start */}
            <aside className={value?"slide-bar show":"slide-bar"}>
                <div className="close-mobile-menu">
                    <a href="#" onClick={onClick}>
                        <i className="fas fa-times"/>
                    </a>
                </div>
                {/* offset-sidebar start */}
                <div className="offset-sidebar">
                    <div className="offset-widget offset-logo mb-30">
                        <Link to="/">
                            <span style={{fontSize: '28px', fontWeight: 'bold', color: 'white', letterSpacing: '1px'}}>Cuy<span style={{color: '#E8913A'}}>Soft</span></span>
                        </Link>
                    </div>
                    <div className="offset-widget mb-40">
                        <div className="info-widget">
                            <h4 className="offset-title mb-20">Sobre Nosotros</h4>
                            <p className="mb-30">
                                En CuySoft impulsamos la innovación y la innovación educativa,
                                desarrollando soluciones tecnológicas que transforman la manera
                                de aprender y enseñar, conectando la tecnología con la educación
                                para generar un impacto real en la sociedad.
                            </p>
                        </div>
                    </div>
                    <div className="offset-widget mb-30 pr-10">
                        <div className="info-widget info-widget2">
                            <h4 className="offset-title mb-20">Información de Contacto</h4>
                            <p>
                                <i className="fal fa-address-book"/>
                                23/A, Miranda City Likaoli Prikano, Dope</p>
                            <p>
                                <i className="fal fa-phone"/>
                                +0989 7876 9865 9
                            </p>
                            <p>
                                <i className="fal fa-envelope-open"/>
                                info@example.com
                            </p>
                        </div>
                    </div>
                    <div className="login-btn text-center">
                        <Link className="theme_btn w-100" to="/login">Iniciar Sesión</Link>
                    </div>
                </div>
                {/* offset-sidebar end */}
            </aside>
            {/* slide-bar end */}
        </Fragment>
    )
}

export default SideBar